import { render, staticRenderFns } from "./TeamPermanentStatisticsComponent.vue?vue&type=template&id=e7fd5f98&"
import script from "./TeamPermanentStatisticsComponent.vue?vue&type=script&lang=js&"
export * from "./TeamPermanentStatisticsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports